'use client';
import React from "react";
import { ThemeColors } from "@/tokens";
import Link from "next/link";
import HomeIcon from "./icons/Home";
import classNames from "classnames";
import Divider from "./atoms/Divider";
import LogoutIcon from "./icons/Logout";
import { useAuth } from "@/contexts/Auth";
import { useGlobal } from "@/contexts/Global";
import Rocket from "../intake/components/Icons/Rocket";
import { SimpleTooltip } from "@/components/ui/simple-tooltip";
import ContentPasteSearch from "../intake/components/Icons/ContentPasteSearch";

const TN_PLATFORM_URL = process.env.NEXT_PUBLIC_TN_PLATFORM_URL ?? 'https://home.talentneuron.com/';


const Sidebar: React.FC = () => {
  const { pdfLayout } = useGlobal();
  const { signOut, user } = useAuth();
  if (pdfLayout) return null;

  const hasTalentNeuronEmail = (user?.email ?? '').endsWith('@talentneuron.com');

  return (
    <aside
      className={classNames('fixed', 'flex', 'flex-col', 'z-[999]','h-screen', 'py-8', 'px-2.5', 'items-center', "justify-between")}
      style={{
        backgroundColor: ThemeColors.primary,
      }}
    >
      <div className="flex flex-col gap-5">
        <SimpleTooltip offsetX={6} className="mb-9" position="right" title="Return to TalentNeuron Platform" >
          <Link href={TN_PLATFORM_URL ?? '#'} className={classNames('flex justify-center')}>
            <HomeIcon className="hover:scale-90 transition-all duration-300" />
          </Link>
        </SimpleTooltip>
        {
          hasTalentNeuronEmail && (
            <SimpleTooltip offsetX={6} className="mb-8" position="right" title="Go to Intake App" >
              <Link href="/intake" className={classNames('!text-white', 'flex justify-center')}>
                <Rocket className="hover:scale-90 transition-all duration-300" width={29} height={29} fill="#fff" />
              </Link>
            </SimpleTooltip>
          )
        }
        {
          hasTalentNeuronEmail && (
            <SimpleTooltip offsetX={6} className="mb-8" position="right" title="Go to Researcher App" >
              <Link href="/member" className={classNames('!text-white', 'flex justify-center')}>
                <ContentPasteSearch className="hover:scale-90 transition-all duration-300" width={24} height={24} fill="#fff" />
              </Link>
            </SimpleTooltip>
          )
        }
      </div>
      <div className={classNames('mb-12', 'flex', 'flex-col', 'w-full', 'items-center')}>
        <Divider orientation="horizontal" />
        <SimpleTooltip className="mt-8" offsetX={6} position="right" title="Logout" >
          <LogoutIcon className="hover:scale-90 transition-all duration-300" role="button" onClick={signOut} />

        </SimpleTooltip>
      </div>

    </aside>
  )
};

export default Sidebar;
